import React, { useEffect, useState } from 'react';
import PdfRenderer from './PdfRenderer';
import ReviewSpinner from '../ReviewSpinner';
import ViewerControls from './ViewerControls';
import { fetchUrl } from 'ducks/reviewDocuments';

const PdfViewer = ({ document }) => {
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState();

  useEffect(() => {
    setLoading(true);
    fetchUrl(document).then(url => setUrl(url));
  }, [document.document_url]);

  return (
    <div className="review-pdf-viewer">
      <ViewerControls document={document}>
        {url && <PdfRenderer url={url} onLoad={() => setLoading(false)}/>}
      </ViewerControls>

      {loading && <ReviewSpinner/>}
    </div>
  );
};

export default PdfViewer;
